import {
  faAddressCard,
  faBars,
  faDollarSign,
  faSearch,
  faShoppingCart,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Table } from "react-bootstrap";
import "./DashboardMain.css";

const DashboardMainCard = ({ name, total, iconName }) => {
  return (
    <div className="dashboard_cardBox_card">
      <div>
        <div className="numbers">{total}</div>
        <div className="cardName">{name}</div>
      </div>
      <div className="iconBox">
        <FontAwesomeIcon icon={iconName} />
      </div>
    </div>
  );
};

const DashboardMain = ({ users, orders, reviews }) => {
  const recentOrders = orders.slice(0, 10);
  console.log({ recentOrders });

  const totalEarnings =
    orders?.length &&
    orders
      .filter((o) => o.status === "approved")
      .map((order) => order.totalPrice)
      .reduce((p = 0, c = 0) => +p + +c, []);
  const numbersList = [
    {
      name: "Total User",
      qty: users?.length || 0,
      iconName: faUsers,
    },
    {
      name: "Orders",
      qty: orders?.length || 0,
      iconName: faShoppingCart,
    },
    {
      name: "Reviews",
      qty: reviews?.length || 0,
      iconName: faAddressCard,
    },
    {
      name: "Earnings",
      qty: totalEarnings || 0,
      iconName: faDollarSign,
    },
  ];

  const toggleMenu = () => {
    let toggle = document.querySelector(".dashboard_toggle");
    let navToggle = document.querySelector(".dashboard_navigation");
    let mainToggle = document.querySelector(".dashboard_main");
    toggle.classList.toggle("active");
    navToggle.classList.toggle("active");
    mainToggle.classList.toggle("active");
  };

  return (
    <div className="dashboard_main">
      <div className="dashboard_topbar w-100">
        <div className="dashboard_toggle" onClick={toggleMenu}>
          <FontAwesomeIcon icon={faBars} className="iconBars" />
        </div>
        <div className="dashboard_search">
          <label htmlFor="searchBox">
            <input
              className=""
              type="text"
              name="searchBox"
              id="searchBox"
              placeholder="search here"
            />
            <FontAwesomeIcon icon={faSearch} className="search_icon" />
          </label>
        </div>
        <div className="dashboard_user">
          <img
            className="img-fluid"
            src="https://i.ibb.co/RSbfzf7/4-190687129806558e-27.jpg"
            alt="user"
          />
        </div>
      </div>

      <div className="dashboard_cardBox">
        {numbersList.map((data) => {
          return (
            <DashboardMainCard
              name={data.name}
              total={data.qty}
              iconName={data.iconName}
            />
          );
        })}
      </div>

      <div className="details row m-2">
        <div className="recentOrders col-12 col-md-12 col-lg-8 mx-auto">
          <div className="cardHeader">
            <h2>Recent Orders</h2>
            <a href="#" className="card_btn">
              View All
            </a>
          </div>
          <Table>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Price</th>
                <th>Payment</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {recentOrders?.length &&
                recentOrders.map((rOrder, i) => {
                  return (
                    <tr key={rOrder?._id}>
                      <td>{i + 1}</td>
                      <td>
                        {rOrder?.products.map((pd) => (
                          <p>{pd?.name}</p>
                        ))}
                      </td>
                      <td>${rOrder?.totalPrice}</td>
                      <td>Card</td>
                      <td>{rOrder?.status}</td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
        {/* <div className="recentCustomers col-12 col-md-6">
          <div className="cardHeader">
            <h2>Recent Customers</h2>
            <a href="#" className="card_btn">
              View All
            </a>
          </div>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Username</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Imran Khan</td>
                <td>Codingbird@yahoo.com</td>
                <td>CodingBird</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Imran Khan</td>
                <td>Codingbird@yahoo.com</td>
                <td>CodingBird</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Imran Khan</td>
                <td>Codingbird@yahoo.com</td>
                <td>CodingBird</td>
              </tr>
            </tbody>
          </Table>
        </div> */}
      </div>
    </div>
  );
};

export default DashboardMain;
